import { useState, useEffect } from 'react';

import { fetchHomeHits } from 'Redux/ducks/algolia-calls';

const useHomePageData = () => {
  const [apiResults, setApiResults] = useState({});
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    const doFetch = async () => {
      try {
        const results = await fetchHomeHits();
        setApiResults(results);
        setTimeout(() => {
          window.prerenderReady = true;
        }, 5000);
      } catch (error) {
        setFetchError(error);
        window.prerenderReady = true;
      }
    };

    doFetch();
  }, []);

  if (fetchError) {
    window.prerenderReady = true;
    throw fetchError;
  }

  return { apiResults, fetchError };
};

export default useHomePageData;
